'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import {Row, Col} from 'react-flexbox-grid'

// import ReactPlayer from 'react-player'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Toolkit = require('./Toolkit.css');

var _Toolkit2 = _interopRequireDefault(_Toolkit);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolkit = (_dec = (0, _reactCssModules2.default)(_Toolkit2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Toolkit, _Component);

  function Toolkit(props) {
    (0, _classCallCheck3.default)(this, Toolkit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Toolkit.__proto__ || (0, _getPrototypeOf2.default)(Toolkit)).call(this, props));

    _this.onCopy = function () {
      _this.setState({ copied: true });
    };

    _this.renderToolkitContent = function (toolkitTitle, url) {
      var message = 'Action toolkit to move your money';

      return _react2.default.createElement(
        'div',
        { styleName: 'toolkit' },
        _react2.default.createElement(
          'div',
          { styleName: 'toolkit-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Step 1 \u2013 Talk to your colleagues and build a coalition'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'To effectively advocate for new offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you\u2019re writing to someone in power, advocating on behalf of 20 or even 10 people carries a lot more weight than just one. One way to spur interest would be sharing the results from your Gun Free Funds search among fellow employees. All plan participants are offered the same group of mutual funds as you are, so they are probably asking the same questions right now.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Some companies have \u201Ccorporate responsibility teams\u201D. If there isn\u2019t one already, it may be time to create one for weapon free investing. Communicate with your co-workers through a company intranet, employee portal, a company newsletter, corporate chats, or social media.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title-spaceabove' },
            'Step 2 \u2013 Identify the best people to speak with'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'The 401(k)/403(b) plan administrator, manager, or coordinator should be known if you are a plan participant, and that\u2019s where to start. There could also be a chief corporate responsibility officer or employee engagement manager, and those could be good resources. An effective method is to go to the LinkedIn pages of those people and find who might have some sympathy for the cause. Do any of them volunteer or have connections with gun violence organizations? Look for indicators that they\u2019re friendly to corporate responsibility and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it\u2019s an important issue for many employees. If it\u2019s a smaller company, the CFO or CEO could be approached directly. In a mid-size or family company, a family member could be more influential.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title-spaceabove' },
            'Step 3 \u2013 Bring a solution to the table'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'The usual starting point in these conversations is: \u201CWe want to reduce the future risk of our 401(k) fund choices. We also want to invest in a peaceful future. How can we enhance our 401(k) choices to do so?\u201D Getting new fund choices added to the list of the existing plan options is a formal process, and could take up to a year to be added. Larger companies often have some form of investment committee, which engages an investment advisor. There may be some funds in your plan that you see contain only one gun company. You could ask the plan administrator to call the fund manager and say, \u201CIs there a substitute for this one company? If you made one change you would be gun free!\u201D'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If the investment advisor and plan administrator refuse to help in swapping out some gun-heavy funds for some gun free funds, you may need to get fellow employees to sign a petition requesting the change and send it to the investment committee. If you are told, \u201CBut you\u2019ll make less money if you\u2019re not invested in guns,\u201D you can say, \u201CActually, guns are a risky investment. We want to diversify, and be part of building a less violent future.\u201D'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title-spaceabove' },
            'Sample letter to plan administrator'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'div',
              { styleName: 'letter-boxquote' },
              _react2.default.createElement(
                'p',
                null,
                'Dear Plan Administrator,'
              ),
              _react2.default.createElement(
                'p',
                null,
                'I am an employee of ',
                _react2.default.createElement(
                  'strong',
                  null,
                  '[Company Name]'
                ),
                ', and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about gun free and socially responsible investment options in the plan.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'I am concerned about the financial and moral risks associated with investing my retirement savings in civilian firearm companies. A growing body of evidence indicates that companies that are socially conscious end up performing better than those that do not. Many large pension funds have already moved to divest from civilian firearms. In the wake of media attention driven by mass shootings, major retailers are moving to restrict or cease gun sales, and lawmakers are discussing increased regulation of the gun industry. These facts point to a substantial financial risk of investing in gun companies.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'I believe it is my right to know what companies my retirement savings are invested in.'
                ),
                ' Can you please tell me how I can find out what gun companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any gun free, socially responsible options?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Socially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that \u201Cenvironmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment\u201D and can be used when making decisions related to fiduciary duty.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'There is an online tool, ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'gunfreefunds.org'
                ),
                ', which screens many commonly available mutual funds for investments in gun companies, and identifies funds that are socially responsible and gun free. ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'If none of our current plan options are socially responsible and gun free, this tool could be used to find suitable mutual funds that could be included in our plan.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Best,'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '[Your Name]'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '[Your contact information (company department, email, phone)]'
                )
              )
            ),
            _react2.default.createElement(
              _reactCopyToClipboard.CopyToClipboard,
              {
                onCopy: _this.onCopy,
                text: _this.state.value },
              _react2.default.createElement(
                'button',
                {
                  styleName: 'letter-boxquote-copy-button' },
                _this.state.copied ? 'Copied!' : 'Copy to clipboard',
                _this.state.copied ? null : _react2.default.createElement(
                  'span',
                  null,
                  '\xA0',
                  _react2.default.createElement('i', { className: 'fa fa-files-o' })
                )
              )
            )
          ),
          _react2.default.createElement(_components.SocialButtons, { message: message, link: url })
        )
      );
    };

    _this.state = {
      value: 'Dear Plan Administrator,\nI am an employee of [Company Name], and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about gun free and socially responsible investment options in the plan.\nI am concerned about the financial and moral risks associated with investing my retirement savings in civilian firearm companies. A growing body of evidence indicates that companies that are socially conscious end up performing better than those that do not. Many large pension funds have already moved to divest from manufacturers of civilian firearms. In the wake of media attention driven by mass shootings, major retailers are moving to restrict or cease gun sales, and lawmakers are discussing increased regulation of the gun industry. These facts point to a substantial financial risk of investing in gun companies.\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what gun companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any gun free, socially responsible options?\nSocially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that "environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment" and can be used when making decisions related to fiduciary duty.\nThere is an online tool, gunfreefunds.org, which screens many commonly available mutual funds for investments in gun companies, and identifies funds that are socially responsible and gun free. If none of our current plan options are socially responsible and gun free, this tool could be used to find suitable mutual funds that could be included in our plan.\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\nBest,\n[Your Name]\n[Your contact information (company department, email, phone)]',
      copied: false
    };
    return _this;
  }

  (0, _createClass3.default)(Toolkit, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Gun free action toolkit';
      var description = 'Get your money out of gun stocks. Use the Gun Free Funds Action Toolkit to make a change and move your money.';
      var url = _config2.default.domain + _config2.default.routes.toolkit;

      var bannerImage = 'green';
      var bannerHeadline = 'Gun free action toolkit';
      var bannerSubtitle = 'Action toolkit to move your money';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-' + bannerImage },
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-headline' },
                  bannerHeadline
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-subtitle' },
                  bannerSubtitle
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'toolkit' },
          _react2.default.createElement(
            'div',
            { styleName: 'toolkit-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'title' },
              'If you\u2019re an individual investor'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'content-info' },
              _react2.default.createElement(
                'p',
                null,
                'It\u2019s your money, and your financial advisor works for you. You just need to discuss what you have learned about your holdings and how you would like them changed to align with your values. An investment professional will advise you of potential risk and you can make your own decisions.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'You can trade your own portfolio, or tell your manager to do it. They may push back and tell you that you\u2019ll make less money. You can reply, \u201CMaybe, maybe not, but it\u2019s my money, I want less risk, and gun companies are a risky business.\u201D It\u2019s a financial advisor\'s job to manage your money, so you should drive home this point in no uncertain terms.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Ask for help finding the best choices. The advisor may say no if you tell them to invest in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. The goal is to remove the risk, not a specific fund; focus on risk, especially future risk, as well as returns. If they\u2019re unwilling to help you with this transition, find a new advisor. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want innovation, you might need a new advisor.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'title' },
              'Adding gun free options to your retirement plan'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'content-info' },
              _react2.default.createElement(
                'p',
                null,
                'If your employer-offered 401(k) already has options that meet your gun-free investing needs, that\'s great! But many plans only offer diversified funds that own the whole market, including gun companies. It is possible to change what the plan offers, but it will take more effort than if you have an IRA or a personal portfolio  that you solely control and has unlimited options. You will need to engage the plan administrator to help find the right blend of options to satisfy the many employees that all invest in the same group of mutual funds. This may take time and possibly some coordination with your co-plan participants.'
              )
            )
          )
        ),
        this.renderToolkitContent(title, url),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          'div',
          { styleName: 'ab-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'ab-container-inner' },
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return Toolkit;
}(_react.Component)) || _class);
exports.default = Toolkit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Toolkit/Toolkit.js
// module id = 1299
// module chunks = 0